





































import Component from 'vue-class-component';
import DataTable from '@/components/table/DataTable.vue';

@Component
export default class ScrollableDataTable extends DataTable {}
